import React from 'react';
import { Skeleton } from '@components/ui/skeleton';
const RegionSelectorModalSkeleton: React.FC = () => <div className="p-6 bg-white dark:bg-zinc-950" data-sentry-component="RegionSelectorModalSkeleton" data-sentry-source-file="region-selector-modal-loader.tsx">
    <div className="space-y-4">
      <Skeleton className="h-6 w-96" data-sentry-element="Skeleton" data-sentry-source-file="region-selector-modal-loader.tsx" />
      <Skeleton className="h-4 w-96" data-sentry-element="Skeleton" data-sentry-source-file="region-selector-modal-loader.tsx" />
      <div className="mt-6 space-y-3">
        {Array.from({
        length: 3
      }).map((_, index) => <Skeleton key={index} className="h-10 w-full rounded-xl" />)}
      </div>
    </div>
  </div>;
export default React.memo(RegionSelectorModalSkeleton);